import RaidItemTable from "./RaidItemTable";

export default RaidItemTable;